<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 12 14">
    <path d="M8.977 8.766q0-0.203-0.148-0.352l-1.414-1.414 1.414-1.414q0.148-0.148 0.148-0.352 0-0.211-0.148-0.359l-0.703-0.703q-0.148-0.148-0.359-0.148-0.203 0-0.352 0.148l-1.414 1.414-1.414-1.414q-0.148-0.148-0.352-0.148-0.211 0-0.359 0.148l-0.703 0.703q-0.148 0.148-0.148 0.359 0 0.203 0.148 0.352l1.414 1.414-1.414 1.414q-0.148 0.148-0.148 0.352 0 0.211 0.148 0.359l0.703 0.703q0.148 0.148 0.359 0.148 0.203 0 0.352-0.148l1.414-1.414 1.414 1.414q0.148 0.148 0.352 0.148 0.211 0 0.359-0.148l0.703-0.703q0.148-0.148 0.148-0.359zM12 7q0 1.633-0.805 3.012t-2.184 2.184-3.012 0.805-3.012-0.805-2.184-2.184-0.805-3.012 0.805-3.012 2.184-2.184 3.012-0.805 3.012 0.805 2.184 2.184 0.805 3.012z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-times-circle.html